<div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-form-field *ngIf="productTemplates" > 
                <mat-label>Select Asset Template</mat-label>
                <mat-select [(ngModel)]="templateType" (selectionChange)="loadData()">
                  <mat-option *ngFor="let productTemplate of productTemplates" [value]="productTemplate">
                    {{ productTemplate }}
                  </mat-option>
                </mat-select>
              </mat-form-field> 
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <button mat-flat-button color="accent" (click)="selectAssets()" [disabled]="selection.isEmpty()">Select</button>
        </div>
    </div>

    <div>
        <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" fxFill matSort>

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

            <ng-container matColumnDef="callerReferenceKey">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Caller Reference Key</th>
                <td mat-cell *matCellDef="let row"> {{row.callerReferenceKey}} </td>
            </ng-container>
        
            <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
                <td mat-cell *matCellDef="let row"> {{row.version}} </td>
            </ng-container>
        
            <ng-container matColumnDef="dateAdded">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Added</th>
                <td mat-cell *matCellDef="let row"> {{row.dateAdded.toString()}} </td>
            </ng-container>
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            
            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">Select an Asset Type.</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[20, 40, 80, 160]" aria-label="Select page"></mat-paginator>
    </div>
</div>